import { useState, useEffect } from "react";
import DatePicker from "react-multi-date-picker";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import {miladiToShamsi} from "../../utils/miladiToShamsi";

export default function InputField({
  label,
  name,
  type = "text",
  value = "",
  placeholder = "",
  onChange,
  error = "",
  disabled = false,
}) {
  const [date, setDate] = useState(null);
  const [lastExternalValue, setLastExternalValue] = useState(value);


  // 🔹 فقط وقتی مقدار بیرونی واقعاً تغییر کرد state داخلی رو آپدیت کن
  useEffect(() => {
    if (type === "date") {
      if (value !== lastExternalValue) {
        setLastExternalValue(value);

        if (value) {
          try {
            const gDate = new DateObject({
              date: value,
              calendar: gregorian,
            });
            const pDate = gDate.convert(persian, persian_fa);
            setDate(pDate);
          } catch (e) {
            console.error("Date conversion error:", e);
            setDate(null);
          }
        } else {
          setDate(null);
        }
      }
    }
  }, [value, type, lastExternalValue]);

  // 🔹 تغییر تاریخ توسط کاربر
  const handleDateChange = (selectedDate) => {
    if (!selectedDate) {
      setDate(null);
      setLastExternalValue(""); // 🔹 اینجا هم آپدیت کن
      onChange({ target: { name, value: "" } });
      return;
    }

    setDate(selectedDate);

    try {
      const miladiDate = new DateObject(selectedDate).convert(gregorian);
      const miladi = miladiDate.format("YYYY-MM-DD");
      setLastExternalValue(miladi); // 🔹 اینجا هم آپدیت کن
      onChange({ target: { name, value: miladi } });
    } catch (error) {
      console.error("Gregorian conversion failed:", error);
      setLastExternalValue(""); // 🔹 اینجا هم آپدیت کن
      onChange({ target: { name, value: "" } });
    }
  };

  return (
    <div className="flex flex-col w-full">
      {label && (
        <label
          htmlFor={name}
          className="text-sm font-medium text-gray-700 mb-2"
        >
          {label}
        </label>
      )}

      {type === "date" ? (
        <DatePicker
          calendar={persian}
          locale={persian_fa}
          value={date}
          onChange={handleDateChange}
          disabled={disabled}
          placeholder={miladiToShamsi(placeholder)}
          format="YYYY/MM/DD"
          inputClass={`border rounded-lg p-2.5 w-full text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#1E3A5F] transition-all
            ${error ? "border-red-500" : "border-gray-300"}
            ${disabled ? "bg-gray-100 cursor-not-allowed" : ""}
          `}
          containerClassName="w-full"
        />
      ) : (
        <input
          id={name}
          name={name}
          type={type}
          value={value ?? ""}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          onWheel={(e) => e.target.blur()}
          className={`border rounded-lg p-2.5 text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#1E3A5F] transition-all
            ${error ? "border-red-500" : "border-gray-300"}
            ${disabled ? "bg-gray-100 cursor-not-allowed" : ""}
          `}
        />
      )}

      {error && (
        <span className="text-xs text-red-600 mt-1">{error}</span>
      )}
    </div>
  );
}